<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Events</h1>
  </div>
  <div class="sky-card-body">
    <app-wiki-link [wiki]="{href: 'https://sky-children-of-the-light.fandom.com/wiki/Special_Events'}"></app-wiki-link>
  </div>
</div>

<!-- Recurring -->
<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3">Recurring events</h2>
  </div>
  <div class="sky-card-body">
    <div class="grid grid-4">
      <app-event-card [event]="event" *ngFor="let event of recurring; let i = index;" [options]="{show: ['img', 'list', 'recent']}"></app-event-card>
    </div>
  </div>
</div>

<!-- Other -->
<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3">Other events</h2>
  </div>
  <div class="sky-card-body">
    <div class="grid grid-4">
      <app-event-card [event]="event" *ngFor="let event of old; let i = index;" [options]="{show: ['img', 'list', 'recent']}"></app-event-card>
    </div>
  </div>
</div>
